import './Heading01.scss';
import clsx from 'clsx';
import React from 'react';

type Props = {
  className?: string;
  as?: React.ElementType;
  children: React.ReactNode;
};

export const Heading01 = ({ className, as: Cmp = 'p', children }: Props): React.ReactElement => (
  <Cmp className={clsx('bp-heading-01', className)}>
    {children}
  </Cmp>
);
